import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import { memoryCrudStateConfig } from "../../../consts";

const memoriesMetaReducer = makeCrudStateReducer(memoryCrudStateConfig);
export default memoriesMetaReducer;
